import { isEmpty, isNumber } from 'mc-ui-utils';
import State from '../state';
import { getFooterHeight, getGlancePreference, setGlancePreference, } from './glanceandroidbridge';
export const d = {
    sideGap: `32px`,
    glanceSideGap: '11px',
    glanceTopGap: '17px',
    glanceBottomGap: `${20 + parseInt(getFooterHeight(), 10)}px`,
};
export const getViewPortDimensions = () => {
    console.log(' getViewPortDimensions ', State.isSdk);
    if (typeof window === 'undefined' || !State.isSdk) {
        return {
            vw: '100%',
            vh: '100%',
        };
    }
    const vw = `${Math.max(window.document.documentElement.clientWidth, window.innerWidth || 0)}px`;
    const vh = `${Math.max(window.document.documentElement.clientHeight, window.innerHeight || 0)}px`;
    console.log(' getViewPortDimensions before return ', { vw, vh });
    return {
        vw,
        vh,
    };
};
export const hasNativeVideo = (glance) => glance && glance.peek && glance.peek.type === 4 /* NATIVE_VIDEO */;
export const isWebpeek = (glance) => glance && glance.peek && glance.peek.type === 3 /* WEB */;
export const hasYoutubeVideo = (glance) => glance && glance.peek && glance.peek.type === 2 /* VIDEO */;
export const humanize = (num) => {
    if (!isNumber(num)) {
        return '';
    }
    return Math.abs(num) > 999
        ? `${(Math.abs(num) / 1000).toFixed(1)}k`
        : `${Math.abs(num)}`;
};
const COACHMARK_SEEN = 'COACHMARK_SEEN';
export const checkCoachMarkShown = () => {
    const hasSeen = getGlancePreference(COACHMARK_SEEN);
    return !isEmpty(hasSeen);
};
export const setCoachMarkShown = () => {
    setGlancePreference(COACHMARK_SEEN, '1');
};
export const generateRandom = (n) => {
    const add = 1;
    let max = 12 - add; // 12 is the min safe number Math.random() can generate without it starting to pad the end with zeros.
    if (n > max) {
        return generateRandom(max) + generateRandom(n - max);
    }
    max = Math.pow(10, n + add);
    const min = max / 10; // Math.pow(10, n) basically
    const number = Math.floor(Math.random() * (max - min + 1)) + min;
    return `${number}`.substring(add);
};
export const fromUTF8ArrayToString = (data) => {
    // array of bytes
    let str = '', i;
    for (i = 0; i < data.length; i++) {
        const value = data[i];
        if (value < 0x80) {
            str += String.fromCharCode(value);
        }
        else if (value > 0xbf && value < 0xe0) {
            str += String.fromCharCode(((value & 0x1f) << 6) | (data[i + 1] & 0x3f));
            i += 1;
        }
        else if (value > 0xdf && value < 0xf0) {
            str += String.fromCharCode(((value & 0x0f) << 12) |
                ((data[i + 1] & 0x3f) << 6) |
                (data[i + 2] & 0x3f));
            i += 2;
        }
        else {
            // surrogate pair
            const charCode = (((value & 0x07) << 18) |
                ((data[i + 1] & 0x3f) << 12) |
                ((data[i + 2] & 0x3f) << 6) |
                (data[i + 3] & 0x3f)) -
                0x010000;
            str += String.fromCharCode((charCode >> 10) | 0xd800, (charCode & 0x03ff) | 0xdc00);
            i += 3;
        }
    }
    return str.replace(/\\\//g, '/');
};
export const toUTF8Array = (str) => {
    const utf8 = [];
    for (let i = 0; i < str.length; i++) {
        let charcode = str.charCodeAt(i);
        if (charcode < 0x80)
            utf8.push(charcode);
        else if (charcode < 0x800) {
            utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
        }
        else if (charcode < 0xd800 || charcode >= 0xe000) {
            utf8.push(0xe0 | (charcode >> 12), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
        }
        // surrogate pair
        else {
            i++;
            // UTF-16 encodes 0x10000-0x10FFFF by
            // subtracting 0x10000 and splitting the
            // 20 bits of 0x0-0xFFFFF into two halves
            charcode =
                0x10000 + (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
            utf8.push(0xf0 | (charcode >> 18), 0x80 | ((charcode >> 12) & 0x3f), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
        }
    }
    return utf8;
};
export const getOverlayImageUrl = (glance) => {
    if (glance.isDynamicOverlay && !isEmpty(glance.dynamicOverlayUri)) {
        return glance.dynamicOverlayUri;
    }
    if (!isEmpty(glance.localOverlayUri)) {
        return glance.localOverlayUri;
    }
    return null;
};
//# sourceMappingURL=common.js.map